import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AppSettings } from 'src/app/app-settings';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { PanelAdminService } from 'src/app/services/panel-admin.service';
import { ReportsService } from 'src/app/services/reports.service';
import { QrCardComponent } from '../../bloques/qr-card/qr-card.component';
import { InfoTicketComponent } from '../../totem/info-ticket/info-ticket.component';
import { InfoCardComponent } from '../../shared/info-card/info-card.component';
import { isSpanishNational, normalizeDigits, spanishNationalPart, toNationalInput } from 'src/app/utils/phone.util';

@Component({
  selector: 'app-confirm-pay',
  templateUrl: './confirm-pay.component.html',
  styleUrls: ['./confirm-pay.component.scss']
})
export class ConfirmPayComponent implements OnInit {

  idDownload!: any;
  error!: string;
  isAdmin: boolean = false;

  // totem
  totemActive: any = AppSettings.ENV_TOTEM;
  openedWhatsapp: boolean = false;
  checkWhatsapp: boolean = false;
  numWhatsapp: string = '';
  /**
   * Con un número español el campo son las 9 cifras nacionales y el prefijo se
   * pinta al lado; con uno extranjero se muestra completo en un solo campo,
   * porque su prefijo no lo sabemos ni lo preguntamos.
   */
  spanishNumber: boolean = true;
  /** El número venía del perfil, para cambiar el texto del diálogo. */
  phonePrefilled: boolean = false;

  constructor(private dialog: MatDialog, @Optional() @Inject(MAT_DIALOG_DATA) public data, private router: Router, private auth: AuthenticationService,
    private panelService: PanelAdminService, private dialogRef: MatDialogRef<ConfirmPayComponent>, private reportService: ReportsService,
    private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.idDownload = this.data?.idOrder;
    let profile = this.auth.getProfile();
    this.isAdmin = profile?.roleFunctions?.length > 0;
    this.prefillPhone(profile);
  }

  /**
   * Precarga el teléfono guardado en el perfil para no hacerlo teclear en cada
   * compra. En el tótem no: allí el usuario logado es el del kiosco, así que
   * precargar su número se lo enseñaría —y se lo enviaría— a quien compra.
   */
  private prefillPhone(profile: any) {
    if (this.totemActive) {
      return;
    }

    if (profile) {
      this.applyProfilePhone(profile.phone);
      return;
    }

    // El perfil vive en memoria y se pide al arrancar, así que tras una recarga
    // completa de página puede no haber llegado todavía — y la vuelta de Redsys
    // a payment-success es justo eso.
    this.auth.getMyData().subscribe(data => this.applyProfilePhone(data?.phone));
  }

  private applyProfilePhone(phone: string | null | undefined) {
    // Si la respuesta llega cuando el usuario ya está escribiendo, no se le pisa.
    if (!phone || this.numWhatsapp) {
      return;
    }

    const digits = normalizeDigits(phone);
    // Vale tanto el canónico como el desnudo de 9 cifras: en base de datos
    // conviven los dos hasta que se lance el backfill que los unifica.
    const national = spanishNationalPart(digits);

    this.spanishNumber = national !== null;
    this.numWhatsapp = national ?? digits;
    this.phonePrefilled = true;
  }

  /** Evita que pegar el número completo duplique el prefijo que ya se ve. */
  onPhoneChange(value: string) {
    this.numWhatsapp = this.spanishNumber
      ? toNationalInput(value)
      : normalizeDigits(value);
  }

  /** El número tal y como se le muestra al usuario en el diálogo de confirmación. */
  get phoneToDisplay(): string {
    const digits = normalizeDigits(this.numWhatsapp);
    return this.spanishNumber ? `+34 ${digits}` : `+${digits}`;
  }

  openPrint() {
    this.reportService.getUrlsDownload(this.idDownload).subscribe({
      next: (res) => {
        const url = res.data;
        let uriDownload = url['ticket_a4'];
        window.open(uriDownload, '_blank');
        this.dialogRef.close({ print: true });
      }, error: (err) => {
        this.error = '¡Vaya! Se ha producido un error al descargar la entrada. Podrá descargarla desde el correo o desde su Perfil.';
      }
    })
  }


  // imprimirPDF(url: string) {
  //   const ventana = window.open(url);

  //   if (ventana) {
  //     ventana.print();

  //     setTimeout(() => {
  //       ventana.close();
  //     }, 2000); // Se espera medio segundo para asegurarse de que el PDF se carga antes de imprimir
  //   }
  // }

  openProfile() {
    // Comprobar si es gestor y mandar a pedidos
    this.dialog.closeAll();
    let url = !this.isAdmin ? '/profile' : '/panel-control/orders/list';
    this.router.navigate([url]);
  }

  goHome() {
    if (this.totemActive) {
      this.router.navigate(['/home-totem']);
    }
    this.dialog.closeAll();
  }

  imprimirPDF(base64String: string) {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    const url = URL.createObjectURL(blob);
    const ventana = window.open(url, '_blank');

    if (ventana) {
      setTimeout(() => {
        ventana.print();
      }, 500); // Se espera medio segundo para asegurarse de que el PDF se carga antes de imprimir
    }
  }

  openTicket() {
    this.dialog.open(InfoTicketComponent, {
      panelClass: 'info-dialog',
      data: {
        idTicket: this.idDownload,
        buyTickets: this.data?.seats
      }
    });
  }

  printPDF() {
    const targetElement: any = document.getElementById("printContainer");
    const WindowPrt: any = window.open('', '', 'left=500,top=100,width=900,height=900,toolbar=0,scrollbars=0,status=0');
    WindowPrt.document.write(targetElement.innerHTML);
    WindowPrt.document.close();
    WindowPrt.focus();
    WindowPrt.print();
    WindowPrt.close();
  }

  goBackModal() {
    this.openedWhatsapp = false;
    this.checkWhatsapp = false;
  }

  sendWhatsapp() {
    const typed = normalizeDigits(this.numWhatsapp);

    if (this.spanishNumber && !isSpanishNational(typed)) {
      this.openInfoCard('Por favor, introduce un número de teléfono válido.')
      return;
    }

    // Un número extranjero llega ya con su prefijo, así que solo se comprueba
    // que quepa en el rango de E.164.
    if (!this.spanishNumber && (typed.length < 9 || typed.length > 15)) {
      this.openInfoCard('Por favor, introduce un número de teléfono válido.')
      return;
    }

    const payload = {
      order: this.idDownload,
      // Como cadena, no como número: un teléfono no es una cantidad, y
      // convertirlo solo puede estropearlo (un cero por la izquierda se pierde).
      phone: this.spanishNumber ? `34${typed}` : typed,
    };
    this.confirmsendWhatsapp(payload);
  }

  confirmsendWhatsapp(payload: any) {
    const dialogConfirm = this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      disableClose: true,
      data: {
        icon: false,
        text: '¿Enviar entradas por WhatsApp al número ' + this.phoneToDisplay + '?',
        btnCancel: false,
        textButton: 'ENVIAR'
      }
    });
    dialogConfirm.afterClosed().subscribe(res => {
      if (res) {
        this.sendWhatsappApi(payload);
      }
    });
  }

  sendWhatsappApi(payload: any) {
    this.reportService.sendWhatsappMessage(payload).subscribe({
      next: (response) => {
        this.checkWhatsapp = true;
      },
      error: (err) => {
        console.error('Error al enviar mensaje de WhatsApp:', err);
        this.openInfoCard('Error al enviar el mensaje de WhatsApp. Por favor, inténtalo de nuevo más tarde.', false);
      }
    });
  }

  openInfoCard(message: string, icon: boolean = true) {
    this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      data: {
        icon: icon,
        text: message,
        btnCancel: false
      }
    });
  }

}
